import { render, staticRenderFns } from "./DoctorNoteDelete.vue?vue&type=template&id=038c84a0&scoped=true&"
import script from "./DoctorNoteDelete.vue?vue&type=script&lang=js&"
export * from "./DoctorNoteDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038c84a0",
  null
  
)

export default component.exports